import { Callout as Callouts } from "@radix-ui/themes";
import { InfoCircledIcon } from "@radix-ui/react-icons";

const Callout: React.FC<{
  copy: { heading?: string; body: { text: string }[] };
  isLast?: boolean;
  isFirst?: boolean;
}> = ({ copy, isLast, isFirst }) => {
  return (
    <Callouts.Root mt={isFirst ? "0" : "4"} mb={isLast ? "0" : "4"} size="3">
      <Callouts.Icon>
        <InfoCircledIcon />
      </Callouts.Icon>
      {copy.heading && (
        <Callouts.Text weight="bold">{copy.heading}</Callouts.Text>
      )}
      <>
        {copy.body.map((item, index) => {
          return (
            <Callouts.Text wrap="pretty" key={index}>
              {item.text}
            </Callouts.Text>
          );
        })}
      </>
    </Callouts.Root>
  );
};

export default Callout;
